module.exports = __webpack_public_path__ + "static/media/60.64065e9a.jpg";